import { IDonorRegistration } from '@nkr/models/index';
import { Col, Label, Row } from 'react-bootstrap'
import { cardBodyStyle, cardBodyTitleStyle, cardStyle, cardBodyTitleTextStyle } from '../../styles';

interface IProps {
    data: IDonorRegistration
}

const IdentityInformation = (props: IProps) => {
    return (
        <div id='identity-information' style={cardStyle}>
            <div style={cardBodyStyle}>
                <div style={cardBodyTitleStyle}>
                    <span style={cardBodyTitleTextStyle}>Identity Information</span>
                </div>
                {props.data.ssn && (
                    <Row>
                        <Col xs={6} sm={4}>
                            <strong>SSN:</strong>
                        </Col>
                        <Col xs={6} sm={2}>
                            {props.data.ssn}
                        </Col>
                    </Row>
                )}

                {props.data.passportNum && (
                    <Row>
                        <Col xs={6} sm={4}>
                            <strong>Passport #:</strong>
                        </Col>
                        <Col xs={6} sm={2}>
                            {props.data.passportNum}
                        </Col>
                    </Row>
                )}

                {props.data.dlNumber && !props.data.passportNum && (
                    <div>
                        <Row>
                            <Col xs={6} sm={4}>
                                <strong>DL Number:</strong>
                            </Col>
                            <Col xs={6} sm={2}>
                                {props.data.dlNumber ?? <Label>not specified</Label>}
                            </Col>
                            <Col xs={6} sm={4}>
                                <strong>DL State:</strong>
                            </Col>
                            <Col xs={6} sm={2}>
                                {props.data.stateProvinceString}
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={6} sm={4}>
                                <strong>Mother's Maiden Name:</strong>
                            </Col>
                            <Col xs={6} sm={2}>
                                {props.data.mothersMaiden ?? <Label>not specified</Label>}
                            </Col>
                        </Row>
                    </div>
                )}
            </div>
        </div>
    );
}

export default IdentityInformation;